import React, { useState, useEffect, useRef } from "react";
import Controller from './Controller.js';
import { gsap, TweenLite } from "gsap";
import HotspotText from "./HotspotText";
import Vimeo from "@vimeo/player"
import Player from "@vimeo/player"
import styled from 'styled-components'
gsap.registerPlugin(TweenLite);

const HotspotMedia = ({mediaType, file, title, text}) => {
    const el = useRef(null); 
    // const progressRef = useRef(null); 
    // const circleRef = useRef(null);
    const [mode, setMode] = useState(null)
    const [player, setPlayer] = useState("")
    // const [duration, setDuration] = useState(null)
    // const [currentTime, setCurrentTime] = useState(null)
    // const controllerRef = useRef(null); 

    useEffect(()=>{      
        // el.current.controls = false;  
        // const pathLength = circleRef.current.getTotalLength();
        // TweenLite.set(circleRef.current, {strokeDasharray:pathLength});
        const iframe = el.current;
        setPlayer(new Player(iframe));
    },[]);

    // const animateProgressBar = value => {
    //     const width = 100 - value
    //     const pathLength = circleRef.current.getTotalLength();
    //     TweenLite.fromTo(circleRef.current, 0, {strokeDashoffset: pathLength}, {strokeDashoffset:width });
    // }

    // const handleTimeChange = () => {
    //     let value;
    //     player.getDuration().then(function(duration) {
    //         setDuration(duration)
    //       }).then(
    //           player.getCurrentTime().then(function(seconds) {
    //               setCurrentTime(seconds)
    //               }).then(function(){
    //                   if (currentTime > 0) {
    //                       value = Math.floor((100 / duration) * currentTime)
    //                   }
    //                   animateProgressBar(value)
    //               })
    //       )
    // }
    // if (player !== "") {
    //     player.on('play', function() {
    //         playUI()
    //     })
    //     player.on('pause', function() {
    //         pauseUI()
    //     })
    // }
    // const playUI = () => {
    //     player.play()
    //     setMode("play")
    //     handleTimeChange();
    // }
    // const pauseUI = () => {
    //     player.pause();
    //     setMode("pause")
    // }
    // const togglePlayPause = e => {
    //     let endedState;
    //     let pausedState;
    //     let started;
    //     player.getCurrentTime().then(function(seconds) {
    //         seconds > 0 ? started=true : started=false;
    //     }).then(player.getEnded().then(function(ended) {
    //         endedState = ended;
    //     })).then(player.getPaused().then(function(paused) {
    //             pausedState = paused;
    //         }).then(function() {
    //             console.log(started)
    //             if (endedState === true || pausedState === true || started === false) {
    //                 playUI()
    //                 return true;
    //             } else {
    //                 pauseUI()
    //                 return true;
    //             }
    //         })
    //     ) 
    // }

    const PauseHandler = e => {
        player.pause();
        setMode("pause")
        return true;
    }

    return (
        <div className="video-container vimeo-container">
            <div className="media-container">
                <div className="embed-container">
                    <iframe 
                        src={`https://player.vimeo.com/video/${file}`}
                        frameBorder="0" 
                        allowFullScreen
                        height="100%"
                        // onClick={togglePlayPause} 
                        controls={false}
                        // onPlaying={handleTimeChange} 
                        className="video" 
                        ref={el} 
                        preload="auto" 
                        loop 
                        playsInline
                    ></iframe>
                </div>
                
                 
                {/* <Controller ref={controllerRef} mode={mode} togglePlayPause={togglePlayPause} el={mediaType==="video" ? "video" : "audio"} circleRef={circleRef}/> */}

                {/* <div className="progressBar">
                    <span ref={progressRef} className="progress"></span>
                </div> */}

            </div>
            <HotspotText title={title} text={text} />
        </div>
    )
}

export default HotspotMedia;